import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { ToasterService } from '../../services/toaster.service';
import { JobsService } from '../../../pages/pages/jobs/jobs.service';
import { firstValueFrom } from 'rxjs';
import { HolAndMessageService } from '../../../pages/pages/hol-and-message/hol-and-message.service';

@Component({
  selector: 'gtapp-select-users',
  standalone: false,
  templateUrl: './select-users.component.html',
  styleUrl: './select-users.component.scss',
})
export class SelectUsersComponent implements OnInit {
  selectedUserIds = signal<any>([]);
  usersToBeExcluded: any = [];

  @Input() shownFrom: string = 'preferredGuards';

  @Input() set onSelectedUsersInput(value: any) {
    const selectedUserIds = new Set(
      (value || [])?.map((user: any) => user?.id),
    );

    this.userList = this.userList?.map((user: any) => ({
      ...user,
      selected: selectedUserIds.has(user?.id),
    }));

    (value || []).forEach((selectedUser: any) => {
      if (!this.userList.some((user: any) => user?.id === selectedUser?.id)) {
        this.userList.push({
          ...selectedUser,
          selected: true,
        });
      }
    });

    this.selectedUserIds.set([...selectedUserIds]);

    setTimeout(() => {
      this.updateSelectedUsers();
    }, 100);
  }

  @Output() onSelectUser = new EventEmitter();

  userList: any = [];
  userSearchList: any = [];
  userNextCursor: string = '';

  constructor(
    private toasterService: ToasterService,
    private jobService: JobsService,
    private pinnedMessageService: HolAndMessageService,
  ) {}

  async ngOnInit() {
    this.usersToBeExcluded = await this.getUsersToBeExcluded();

    this.getUsers();
  }
  async getUsersToBeExcluded() {
    switch (this.shownFrom) {
      case 'addEditPinnedMessage':
        // only allow 3 messages per user. so get the users that have already 3 messages pinned to them
        const response: any = await firstValueFrom(
          this.pinnedMessageService.getPinnedMessages({ exhausted_users: 1 }),
        );
        return response?.data || [];
    }
    return [];
  }
  getUsers() {
    let params: any = { rows: 30 };
    let body: any = {};

    if (this.userNextCursor) {
      params['next_cursor'] = this.userNextCursor;
    }

    if (this.usersToBeExcluded?.length || this.selectedUserIds()?.length) {
      body['exclude_user_ids'] = [
        ...(this.usersToBeExcluded || []),
        ...(this.selectedUserIds() || []),
      ];
    }

    this.jobService
      .getUserList(params, body)
      .subscribe(async (response: any) => {
        if (response?.status != 'success') {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
          return;
        }
        const existingIds = new Set(
          this.userList?.map((item: any) => item?.id),
        );

        this.userList.push(
          ...(response?.data || []).filter(
            (item: any) => !existingIds.has(item?.id),
          ),
        );

        this.userNextCursor = response?.next_cursor;
      });
  }

  updateSelectedUsers() {
    this.userList = this.userList?.filter((user: any) =>
      user?.selected ? true : !this.usersToBeExcluded?.includes(user?.id),
    );
    this.userList.sort((a: any, b: any) => {
      const isASelected = !!a?.selected;
      const isBSelected = !!b?.selected;

      if (isASelected == isBSelected) {
        const nameA = a?.full_name || '';
        const nameB = b?.full_name || '';
        return nameA.localeCompare(nameB);
      }

      return isASelected ? -1 : 1;
    });
  }
  searchAssignee(event?: any) {
    if (event.target.value?.length <= 2) return;

    this.jobService
      .getUserList({ search_str: event?.target?.value })
      .subscribe(async (response: any) => {
        if (response['status'] == 'success') {
          this.userSearchList = response?.data?.filter(
            (value1: any) =>
              !this.selectedUserIds()?.some(
                (value2: any) => value1?.id === value2?.id,
              ),
          );
        }
      });
  }
}
